import Dexie from "dexie";

export const db = new Dexie("myDB");
db.version(1).stores({ items: "prid,file" });